import { GetTeamMetricsAppsSummaryResponseDto } from '../../../dtos/team-metrics/calendar/get-team-metrics-apps-summary.response.dto';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetTeamMetricsAppsSummaryTotalIndividualRequestDto } from '../../../dtos/team-metrics/calendar/get-team-metrics-apps-summary-total-individual.request.dto';
import { TeamMetricsAppsSummaryTotalIndividualParentAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/calendar/team-metrics-app-summary-total-individual-parent.aggregate-root.mapper';
import { GetTeamMetricsAppsSummaryTotalIndividualQuery } from '../../../queries/team-metrics/calendar/get-team-metrics-apps-summary-total-individual.query';

export class GetTeamMetricsAppsSummaryTotalIndividualController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamMetricsAppsSummaryTotalIndividualQuery,
    protected readonly mapper: TeamMetricsAppsSummaryTotalIndividualParentAggregateRootMapper
  ) {}

  async get(
    props: GetTeamMetricsAppsSummaryTotalIndividualRequestDto
  ): Promise<GetTeamMetricsAppsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `TeamMetricsAppsSummaryTotalIndividualComponentController.get encountered an error ${error}`
      );
    }
  }
}
